import HomeSliderRepository from '../HomeSliderRepository.js';
import HomeStepsRepository from '../HomeStepsRepository.js';
import HomeTestimonialsRepository from '../HomeTestimonialsRepository.js';

import ShopBannersRepository from '../ShopBannersRepository.js';
import ShopPlansRepository from '../ShopPlansRepository.js';
import ShopTestimonialsRepository from '../ShopTestimonialsRepository.js';
import ShopPromosRepository from '../ShopPromosRepository.js';

import ShopCheckoutBannersRepository from '../ShopCheckoutBannersRepository.js';

import ShopAssignmentBannersRepository from '../ShopAssignmentBannersRepository.js';

import ShopMerchantsRepository from '../ShopMerchantsRepository.js';
import ShopMerchantBannersRepository from '../ShopMerchantBannersRepository.js';
import ShopMerchantPlansRepository from '../ShopMerchantPlansRepository.js';
import MerchantBillingDetailsRepository from '../MerchantBillingDetailsRepository.js';

import ShopPromotionsRepository from '../ShopPromotionsRepository.js';
import ShopPromotionBannersRepository from '../ShopPromotionBannersRepository.js';
import ShopPromotionPlansRepository from '../ShopPromotionPlansRepository.js';
import PromotionBillingDetailsRepository from '../PromotionBillingDetailsRepository.js';

import MedgateAppBannersRepository from '../MedgateAppBannersRepository.js';
import MedgateAppFeaturesRepository from '../MedgateAppFeaturesRepository.js';
import MedgateAppFaqsRepository from '../MedgateAppFaqsRepository.js';

import MediaArticlesRepository from '../MediaArticlesRepository.js';

import BusinessBannersRepository from '../BusinessBannersRepository.js';
import BusinessTestimonialsRepository from '../BusinessTestimonialsRepository.js';

import PrivacyBannersRepository from '../PrivacyBannersRepository.js';
import PrivacyPoliciesRepository from '../PrivacyPoliciesRepository.js';

import AboutBannersRepository from '../AboutBannersRepository.js';
import AboutSectionsRepository from '../AboutSectionsRepository.js';
import AboutProgramsRepository from '../AboutProgramsRepository.js';

import JobsRepository from '../JobsRepository.js';

import VideoBannersRepository from '../VideoBannersRepository.js';
import VideoDescriptionsRepository from '../VideoDescriptionsRepository.js';

import PartnersRepository from '../PartnersRepository.js';

import ContactBannersRepository from '../ContactBannersRepository.js';

import CallbackBannersRepository from '../CallbackBannersRepository.js';
import JobsBannersRepository from '../JobsBannersRepository.js';

import BillingDetailsRepository from '../BillingDetailsRepository.js';

import FootersRepository from '../FootersRepository.js';

import TermsAndConditionsRepository from '../TermsAndConditionsRepository.js';

import FormEmailRepository from '../FormEmailRepository.js';

import KeyAssignmentRepository from '../KeyAssignmentRepository.js';

import ResellerRepository from '../ResellerRepository.js';
import ResellerShopBannersRepository from '../ResellerShopBannersRepository.js';
import ResellerShopPlansRepository from '../ResellerShopPlansRepository.js';
import ResellerShopStepsRepository from '../ResellerShopStepsRepository.js';
import ResellerBillingDetailsRepository from '../ResellerBillingDetailsRepository.js';

import JobTestimonialsRepository from '../JobTestimonialsRepository.js';

const repositories = {
    'homeSlider': HomeSliderRepository,
    'homeSteps': HomeStepsRepository,
    'homeTestimonials': HomeTestimonialsRepository,

    'shopBanners': ShopBannersRepository,
    'shopPlans': ShopPlansRepository,
    'shopTestimonials': ShopTestimonialsRepository,
    'shopPromos': ShopPromosRepository,

    'shopCheckoutBanners': ShopCheckoutBannersRepository,

    'shopAssignmentBanners': ShopAssignmentBannersRepository,

    'shopMerchants': ShopMerchantsRepository,
    'shopMerchantBanners': ShopMerchantBannersRepository,
    'shopMerchantPlans': ShopMerchantPlansRepository,
    'shopMerchantBillingDetails': MerchantBillingDetailsRepository,

    'shopPromotions': ShopPromotionsRepository,
    'shopPromotionBanners': ShopPromotionBannersRepository,
    'shopPromotionPlans': ShopPromotionPlansRepository,
    'shopPromoBillingDetails': PromotionBillingDetailsRepository,

    'medgateAppBanners': MedgateAppBannersRepository,
    'medgateAppFeatures': MedgateAppFeaturesRepository,
    'medgateAppFaqs': MedgateAppFaqsRepository,

    'mediaArticles': MediaArticlesRepository,

    'businessBanners': BusinessBannersRepository,
    'businessTestimonials': BusinessTestimonialsRepository,

    'privacyBanners': PrivacyBannersRepository,
    'privacyPolicies': PrivacyPoliciesRepository,

    'aboutBanners': AboutBannersRepository,
    'aboutSections': AboutSectionsRepository,
    'aboutPrograms': AboutProgramsRepository,

    'jobs': JobsRepository,
    'jobBanners': JobsBannersRepository,

    'videoBanners': VideoBannersRepository,
    'videoDescriptions': VideoDescriptionsRepository,

    'partners': PartnersRepository,

    'contactBanners': ContactBannersRepository,

    'callbackBanners': CallbackBannersRepository,

    'billingDetails': BillingDetailsRepository,

    'footers': FootersRepository,

    'termsAndConditions': TermsAndConditionsRepository,
    'formEmails': FormEmailRepository,

    'keyAssignments': KeyAssignmentRepository,

    'resellers': ResellerRepository,
    'resellerShopBanners': ResellerShopBannersRepository,
    'resellerShopPlans': ResellerShopPlansRepository,
    'resellerShopSteps': ResellerShopStepsRepository,
    'resellerBillingDetails': ResellerBillingDetailsRepository,

    'jobTestimonials': JobTestimonialsRepository
}

export default {
    get: name => repositories[name]
};